<app-note-form
	[hasHeader]="false"
	[showMessage]="false"
	[showLabel]="false"
	marginCls=""
	contenteditable="true"
	(keydown)="onKeyDown($event)"
	(dblclick)="mouseDblClick($event)"
></app-note-form>
